/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment} from "react";
import {Row} from "react-bootstrap";
import {RemoveItemButton as defaultRemoveItemButton} from "./Buttons/RemoveItemButton";
import {EditItemButton as defaultEditItemButton} from "./Buttons/EditItemButton";

export const MutableListRow = (props) => {
    
    const {
        isEditable = false,
        
        editItemButton,
        show,
        
        rowClassName,
        
        item,
        itemClassName,
        ItemComponent,
        isItemEditable = (item) => true,
        updateItem,
        additionalItemComponentProps,
        title,
        subtitle,
        
        /* edit props */
        onEditItem,
        EditItemButton = defaultEditItemButton,
        showEditButton = (item) => false,
        
        /* remove props */
        RemoveItemRow = null,
        RemoveItemButton = defaultRemoveItemButton,
        showRemoveButton = (item) => true,
        onRemoveItem,
        
    } = props;
    
    const editable = isEditable && isItemEditable(item);
    
    return <Fragment>
        {editable && RemoveItemRow && (
            <RemoveItemRow className={rowClassName}>
                <RemoveItemButton
                    item={item}
                    onRemove={onRemoveItem}
                    show={show}
                />
            </RemoveItemRow>
        )}
        <Row className={rowClassName}>
            <div className={itemClassName}>
                <ItemComponent
                    Item={item}
                    
                    {...additionalItemComponentProps}
                    UpdateItem={updateItem}
                    Editable={isEditable}
                    title={title}
                    subtitle={subtitle}
                />
            </div>
            {editable && EditItemButton && (
                <EditItemButton
                    item={item}
                    onEdit={onEditItem}
                    show={showEditButton}
                />
            )}
            {editable && !RemoveItemRow && RemoveItemButton && (
                <RemoveItemButton
                    item={item}
                    onRemove={onRemoveItem}
                    show={show}
                />
            )}
        </Row>
    </Fragment>;
};
